var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "integralUser seller-style" },
    [
      _c("h2", { staticClass: "f18 lin-25 fb normal gray_2" }, [
        _vm._v("拼单管理")
      ]),
      _c("div", { staticClass: "box30" }),
      _c(
        "div",
        [
          _c("div", { staticClass: "flex items-center justify-between" }, [
            _c(
              "div",
              { staticClass: "flex flex1 items-center" },
              [
                _c("el-input", {
                  staticClass: "w210 mar20_r",
                  attrs: { placeholder: "请输入活动编号" },
                  model: {
                    value: _vm.searchForm.id,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.searchForm,
                        "id",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "searchForm.id"
                  }
                }),
                _c("el-input", {
                  staticClass: "w210 mar20_r",
                  attrs: { placeholder: "请输入活动名称" },
                  model: {
                    value: _vm.searchForm.name,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.searchForm,
                        "name",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "searchForm.name"
                  }
                }),
                _c(
                  "el-select",
                  {
                    staticClass: "w210 mar20_r",
                    attrs: { placeholder: "请选择状态" },
                    model: {
                      value: _vm.searchForm.status,
                      callback: function($$v) {
                        _vm.$set(_vm.searchForm, "status", $$v)
                      },
                      expression: "searchForm.status"
                    }
                  },
                  _vm._l(_vm.statusList, function(item) {
                    return _c("el-option", {
                      key: item.id,
                      attrs: { label: item.name, value: item.id }
                    })
                  }),
                  1
                ),
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.searchList } },
                  [_vm._v("查询")]
                ),
                _c("el-button", { on: { click: _vm.restList } }, [
                  _vm._v("重置")
                ])
              ],
              1
            ),
            _c(
              "div",
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.toDetail("")
                      }
                    }
                  },
                  [_vm._v("添加拼单")]
                )
              ],
              1
            )
          ]),
          _c("div", { staticClass: "box30" }),
          _c(
            "el-table",
            {
              attrs: { border: "", data: _vm.list, "row-class-name": "pointer" }
            },
            [
              _c("el-table-column", {
                attrs: { prop: "id", label: "活动编号", "min-width": "10%" }
              }),
              _c("el-table-column", {
                attrs: { prop: "name", label: "活动名称", "min-width": "15%" }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "priceType",
                  label: "活动类型",
                  "min-width": "12%"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.priceType === 1
                          ? _c("span", [_vm._v("阶梯拼单")])
                          : scope.row.priceType === 2
                          ? _c("span", [_vm._v("秒杀拼单")])
                          : _c("span", [_vm._v("集采拼单")])
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "startTime",
                  label: "开始时间",
                  "min-width": "15%"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "endTime",
                  label: "结束时间",
                  "min-width": "15%"
                }
              }),
              _c("el-table-column", {
                attrs: { prop: "status", label: "状态", "min-width": "10%" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.status === 0
                          ? _c("span", { staticClass: "blue" }, [
                              _vm._v("未开始")
                            ])
                          : scope.row.status === 1
                          ? _c("span", { staticClass: "red" }, [
                              _vm._v("进行中")
                            ])
                          : _c("span", [_vm._v("已结束")])
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "290" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.status === 2
                          ? _c(
                              "el-button",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.toDetail(scope.row.id, "end")
                                  }
                                }
                              },
                              [_vm._v("详情")]
                            )
                          : _c(
                              "el-button",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.toDetail(scope.row.id)
                                  }
                                }
                              },
                              [_vm._v("编辑")]
                            ),
                        _c(
                          "el-button",
                          {
                            attrs: { loading: scope.row.shareLoading },
                            on: {
                              click: function($event) {
                                return _vm.toShare(
                                  scope.row.id,
                                  scope.row.name,
                                  scope.$index
                                )
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(scope.row.shareLoading ? "加载中" : "分享")
                            )
                          ]
                        ),
                        scope.row.status === 0
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: {
                                  click: function($event) {
                                    return _vm.delItem(scope.row.id)
                                  }
                                }
                              },
                              [_vm._v("删除")]
                            )
                          : _c(
                              "el-button",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.toOrderList(scope.row.id)
                                  }
                                }
                              },
                              [_vm._v("订单汇总")]
                            )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "flex items-center mar40-t" },
            [
              _c("div", { staticClass: "gray9 flex-auto" }, [
                _vm._v(
                  "共 " +
                    _vm._s(_vm.pageTotal) +
                    " 条记录 第 " +
                    _vm._s(_vm.pageNum) +
                    " / " +
                    _vm._s(_vm.totalPage) +
                    " 页"
                )
              ]),
              _c("el-pagination", {
                attrs: {
                  layout: "prev, pager, next, sizes, jumper",
                  background: "",
                  "hide-on-single-page": "",
                  "page-size": _vm.pageSize,
                  "page-count": _vm.totalPage,
                  "current-page": _vm.pageNum,
                  "page-sizes": [10, 50, 100]
                },
                on: {
                  "update:pageSize": function($event) {
                    _vm.pageSize = $event
                  },
                  "update:page-size": function($event) {
                    _vm.pageSize = $event
                  },
                  "update:currentPage": function($event) {
                    _vm.pageNum = $event
                  },
                  "update:current-page": function($event) {
                    _vm.pageNum = $event
                  },
                  "size-change": _vm.sizeChange,
                  "current-change": _vm.currentChange
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "分享",
            visible: _vm.shareVisible,
            "close-on-click-modal": false,
            width: "500px",
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.shareVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "text-center seller-style" },
            [
              _c("div", { staticClass: "f18 gray6 fb mar15-b" }, [
                _vm._v(_vm._s(_vm.shareInfo.name))
              ]),
              _c("div", { staticClass: "f12" }, [
                _vm._v("保存二维码或链接直接分享好友参加活动")
              ]),
              _c("div", [
                _c("img", {
                  staticClass: "mar10-t mar15-b w160",
                  attrs: { src: _vm.shareInfo.qrcodeImgUrl }
                })
              ]),
              _c(
                "el-button",
                {
                  staticClass: "share-btn",
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.shareSave("img")
                    }
                  }
                },
                [_vm._v("下载二维码")]
              ),
              _c("div", { staticClass: "mar20-t" }, [
                _c("span", { staticClass: "share-url" }, [
                  _vm._v(_vm._s(_vm.shareInfo.shareUrl))
                ]),
                _c(
                  "span",
                  {
                    staticClass: "mar20-l blue pointer",
                    on: {
                      click: function($event) {
                        return _vm.shareSave("url")
                      }
                    }
                  },
                  [_vm._v("复制")]
                )
              ])
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }